import { MESSAGE_RECEIVE_PERMISSION } from '../constants/constants';

interface IPushNotificationSettingsResponse {
  Matches?: boolean;
  RHPTeamMessages?: boolean;
  Favourites?: any;
  Likes?: any;
  Messages?: any;
  Views?: any;
  DateFinderInterest?: boolean;
  PushTags?: string;
  StoryComment?: boolean;
  ForumComment?: boolean;
  EventComment?: boolean;
  GroupChat?: any;
}

export default class PushNotificationSettings {
  matches: boolean;
  rhpTeamMessages: boolean;
  favourites: any;
  likes: any;
  messages: any;
  views: any;
  dateFinderInterest: boolean;
  storyComment: boolean;
  forumComment: boolean;
  eventComment: boolean;
  pushTags: string = '';
  groupChat: any = MESSAGE_RECEIVE_PERMISSION.ANYONE;
  isEnabled: boolean;

  constructor() {
    this.matches = false;
    this.rhpTeamMessages = false;
    this.favourites = MESSAGE_RECEIVE_PERMISSION.ANYONE;
    this.likes = MESSAGE_RECEIVE_PERMISSION.ANYONE;
    this.messages = MESSAGE_RECEIVE_PERMISSION.ANYONE;
    this.views = MESSAGE_RECEIVE_PERMISSION.ANYONE;
    this.dateFinderInterest = false;
    this.storyComment = false;
    this.forumComment = false;
    this.eventComment = false;
    this.isEnabled = false;
  }

  static mappingObject(_obj: IPushNotificationSettingsResponse) {
    const obj = new PushNotificationSettings();
    obj.matches = _obj.Matches || false;
    obj.rhpTeamMessages = _obj.RHPTeamMessages || false;
    obj.favourites = _obj.Favourites || MESSAGE_RECEIVE_PERMISSION.ANYONE;
    obj.likes = _obj.Likes || MESSAGE_RECEIVE_PERMISSION.ANYONE;
    obj.messages = _obj.Messages || MESSAGE_RECEIVE_PERMISSION.ANYONE;
    obj.views = _obj.Views || MESSAGE_RECEIVE_PERMISSION.ANYONE;
    obj.dateFinderInterest = _obj.DateFinderInterest || false;
    obj.pushTags = _obj.PushTags || '';
    obj.storyComment = _obj.StoryComment || false;
    obj.forumComment = _obj.ForumComment || false;
    obj.eventComment = _obj.EventComment || false;
    obj.groupChat = _obj.GroupChat || MESSAGE_RECEIVE_PERMISSION.ANYONE;
    return obj;
  }
}
